

import React, { useState } from 'react';
import { json, NavLink ,useLocation} from 'react-router-dom';
import { msalConfig, loginRequest } from "config/authConfig";
import { FaMicrosoft } from "react-icons/fa";
import {
  clearMsalInteractionState,
  getMicrosoftAuthErrorMessage,
  hasMicrosoftLoginInProgress,
  initializeMsal,
  markMicrosoftLoginStarted,
  msalInstance,
} from "config/msalClient";
// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
// Custom components
import { HSeparator } from 'components/separator/Separator';
import DefaultAuth from 'layouts/auth/variants/Default';
// Assets
// import illustration from 'assets/img/auth/auth.png';
// import illustration from 'assets/img/auth/book.png';
import illustration from 'assets/img/avatars/LogoAtlantis.png';
import { FcGoogle } from 'react-icons/fc';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import AuthApi from 'api/auth';
import { useAuth } from 'contexts/auth.context';
import { useNavigate } from 'react-router-dom';

import {
  learnerLogin,
  checkLearner,
} from 'utils/gameApplication/learnerProfile';
import OnToast from 'components/alerts/toast';
import { HashLoader } from 'react-spinners';
import { updateLearner } from 'utils/leaner/leaner';
function SignIn() {
  const authConfigValid = Boolean(msalConfig?.auth?.clientId && msalConfig?.auth?.authority);
  // Chakra color mode
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const textColorDetails = useColorModeValue('navy.700', 'secondaryGray.600');
  const textColorBrand = useColorModeValue('brand.500', 'white');
  const textColorError = useColorModeValue('red.500', 'red');
  const brandStars = useColorModeValue('brand.500', 'brand.400');
  const googleBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.200');
  const googleText = useColorModeValue('navy.700', 'white');
  const googleHover = useColorModeValue(
    { bg: 'gray.200' },
    { bg: 'whiteAlpha.300' },
  );
  const googleActive = useColorModeValue(
    { bg: 'secondaryGray.300' },
    { bg: 'whiteAlpha.200' },
  );
  const [show, setShow] = React.useState(false);
  const [formData, setFormData] = React.useState({
    email: '', // DEFAULT Auth HERE (email)
    password: '', // DEFAULT Auth HERE (password)
  });
  const [error, setError] = React.useState('');
  const [alert, setAlert] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const token = localStorage.getItem('user');
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useAuth();
  const [showEula, setShowEula] = useState(false); //state for terms and condtions popup
  const location = useLocation();
  const [learnerId, setLearnerId] = useState<number | null>(null);
  const navigate = useNavigate();
  const microsoftLoginStarting = React.useRef(false);
  const handleClick = () => setShow(!show);
	
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const microsoftErrorParam = params.get('microsoftError');
    const microsoftErrorStorage = sessionStorage.getItem('microsoftError');
    const microsoftError = microsoftErrorParam
      ? decodeURIComponent(microsoftErrorParam)
      : microsoftErrorStorage;
    if (microsoftError) {
      setMsg(microsoftError);
      setToastStatus('error');
      setAlert(true);
      sessionStorage.removeItem('microsoftError');
    }
  }, [location.search]);
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

//   const handleLogin = async (event: any) => {
//     event.preventDefault();
//     let data = JSON.stringify(formData);
//     if (formData?.email === '' || formData?.password === '') {
//       setMsg('Please Enter the  Username And Password');
//       setToastStatus('error');
//       setAlert(true);
//       return false;
//     }

//     setLoading(true);
//     try {
//       const result = await learnerLogin(data);
//       if (result?.status !== 'Success') {
//         setMsg('Incorrect Username Or Password');
//         setToastStatus('error');
//         setAlert(true);
//         return false;
//       }
//       // let valid = {
//       //   data: result?.data,
//       //   token: result?.token,
//       //   role: result?.role,
//       // };
//       // let user = JSON.stringify(valid);
//       // setUser(user);
//       // localStorage.setItem('user', user);

//       let valid = {
//   data: result?.data,
//   token: result?.token,
//   role: result?.role,
// };

// // Set user state as object
// setUser(valid);

// // Store full user object
// localStorage.setItem('user', JSON.stringify(valid));

// // Store token separately
// localStorage.setItem('token', result?.token);
//       // navigate('/game/dashboards');
//       // navigate('/game/gamePlay');
//       // window.location.reload();
//       if (result?.data?.lenTerms === true) {
//         // setShowEula(false);
//         navigate('/game/gamePlay');
//       } else {
//         setShowEula(true);
//       }
//     } catch (error) {
//       setMsg('An error occurred. Please try again later.');
//       setToastStatus('error');
//       setAlert(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCheckLearner = async (event: any) => {
//     event.preventDefault();
//     let data = JSON.stringify(formData);
//     if (formData?.email === '' || formData?.password === '') {
//       setMsg('Please Enter the  Username And Password');
//       setToastStatus('error');
//       setAlert(true);
//       return false;
//     }

//     setLoading(true);
//     try {
//       const result = await checkLearner(data);
//       if (result?.status !== 'Success') {
//         setMsg('Incorrect Username Or Password');
//         setToastStatus('error');
//         setAlert(true);
//         return false;
//       }
//       // Store lenId in state
//       setLearnerId(result?.data?.lenId);

//       if (result?.data?.lenTerms === true) {
//         handleLogin(event);
//         //  navigate('/game/gamePlay');
//       } else {
//         setShowEula(true);
//       }
//     } catch (error) {
//       setMsg('An error occurred. Please try again later.');
//       setToastStatus('error');
//       setAlert(true);
//     } finally {
//       setLoading(false);
//     }
//   };

const handleLogin = async (event: any) => {
    event.preventDefault();
    let data = JSON.stringify(formData);
    if (formData?.email === '' || formData?.password === '') {
      setMsg('Please Enter the  Username And Password');
      setToastStatus('error');
      setAlert(true);
      return false;
    }

    setLoading(true);
    try {
      const result = await learnerLogin(data);
      if (result?.status !== 'Success') {
        setMsg('Incorrect Username Or Password');
        setToastStatus('error');
        setAlert(true);
        return false;
      }
     

      let valid = {
  data: result?.data,
  token: result?.token,
  role: result?.role,
};

setUser(valid);

// Store full user object
localStorage.setItem('user', JSON.stringify(valid));

// Store token separately
localStorage.setItem('token', result?.token);
     
      if (result?.data?.lenTerms === true) {
        // setShowEula(false);
        navigate('/game/gamePlay');
      } else {
        setShowEula(true);
      }
    }
    //  catch (error) {
    //   setMsg('An error occurred. Please try again later.');
    //   setToastStatus('error');
    //   setAlert(true);
    // }
    //  finally {
    //   setLoading(false);
    // }

    catch (error: any) {
    console.log("Login Error:", error);

    if (error.response) {
      // Server returned an error (400, 401, 500...)
      setMsg(error.response.data.message || "Login failed.");
    } else if (error.request) {
      // No response received (network/firewall/server down)
      setMsg(
        "Unable to connect to the server. Please check your internet connection or firewall settings and try again."
      );
    } else {
      // Unexpected error
      setMsg("An unexpected error occurred. Please try again later.");
    }

    setToastStatus("error");
    setAlert(true);
  } finally {
    setLoading(false);
  }

  };

  const handleCheckLearner = async (event: any) => {
    event.preventDefault();
    let data = JSON.stringify(formData);
    if (formData?.email === '' || formData?.password === '') {
      setMsg('Please Enter the  Username And Password');
      setToastStatus('error');
      setAlert(true);
      return false;
    }

    setLoading(true);
    try {
      const result = await checkLearner(data);
      if (result?.status !== 'Success') {
        setMsg('Incorrect Username Or Password');
        setToastStatus('error');
        setAlert(true);
        return false;
      }
      // Store lenId in state
      setLearnerId(result?.data?.lenId);

      if (result?.data?.lenTerms === true) {
        handleLogin(event);
        //  navigate('/game/gamePlay');
      } else {
        setShowEula(true);
      }
    } 
    // catch (error) {
    //   setMsg('An error occurred. Please try again later.');
    //   setToastStatus('error');
    //   setAlert(true);
    // } 
    // finally {
    //   setLoading(false);
    // }
    catch (error: any) {
    console.error("Check Learner Error:", error);

    if (error.code === "ERR_NETWORK") {
      setMsg(
        "Unable to connect to the server. Please check your internet connection or firewall settings."
      );
    } else if (error.response) {
      setMsg(
        error.response.data.message ||
          "Unable to verify your account. Please try again."
      );
    } else if (error.request) {
      setMsg(
        "No response from the server. Please check your network connection and try again."
      );
    } else {
      setMsg("An unexpected error occurred. Please try again later.");
    }

    setToastStatus("error");
    setAlert(true);
  } finally {
    setLoading(false);
  }
  };


const login = async () => {
    if (loading || microsoftLoginStarting.current) {
      return;
    }

    if (!authConfigValid) {
      setMsg('Azure AD login is not configured correctly. Please set REACT_APP_AZURE_CLIENT_ID and REACT_APP_AZURE_AUTHORITY.');
      setToastStatus('error');
      setAlert(true);
      return;
    }

    microsoftLoginStarting.current = true;
    setLoading(true);

    try {
      if (hasMicrosoftLoginInProgress()) {
      
        clearMsalInteractionState();
      }

      await initializeMsal();
     
      markMicrosoftLoginStarted();
      await msalInstance.loginRedirect({
        ...loginRequest,
        redirectStartPage: msalConfig.auth.redirectUri,
      });
    } catch (error: any) {
      const errorMessage = error?.message || '';
      const isInteractionInProgress =
        error?.errorCode === 'interaction_in_progress' ||
        errorMessage.includes('interaction_in_progress');

      if (isInteractionInProgress) {
        try {
          clearMsalInteractionState();
          markMicrosoftLoginStarted();
          await msalInstance.loginRedirect({
            ...loginRequest,
            redirectStartPage: msalConfig.auth.redirectUri,
          });
          return;
        } catch (retryError: any) {
          console.error('Microsoft login retry failed:', retryError);
        }
      } else {
        console.error('Microsoft login failed:', error);
      }

      clearMsalInteractionState();
      setMsg(getMicrosoftAuthErrorMessage(error));
      setToastStatus('error');
      setAlert(true);
    } finally {
      microsoftLoginStarting.current = false;
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <DefaultAuth illustrationBackground={illustration} image={illustration}>
         <Box
    h="100vh"
    overflowY="auto"
    overflowX="hidden"
      sx={{
    /* Chrome, Edge, Safari */
    "&::-webkit-scrollbar": {
      display: "none",
    },

    /* Firefox */
    scrollbarWidth: "none",

    /* IE & old Edge */
    msOverflowStyle: "none",
  }}
    px={{ base: "20px", md: "40px" }}
  >
        <Flex
          maxW={{ base: '100%', md: 'max-content' }}
          w="100%"
          mx={{ base: 'auto', lg: '0px' }}
          me="auto"
          h="100%"
          alignItems="start"
          justifyContent="center"
          mb={{ base: '30px', md: '60px' }}
          px={{ base: '25px', md: '0px' }}
          mt={{ base: '40px', md: '14vh' }}
          flexDirection="column"
        >
          <Box me="auto">
            <Heading color={textColor} fontSize="36px" mb="15px">
              Sign In
            </Heading>
           
          </Box>
         
            <Flex
              zIndex="2"
              direction="column"
              w={{ base: '100%', md: '420px' }}
              maxW="100%"
              background="transparent"
              borderRadius="15px"
              mx={{ base: 'auto', lg: 'unset' }}
              me="auto"
              mb={{ base: '20px', md: 'auto' }}
            >
             
              <FormControl>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Email<Text color={brandStars}>*</Text>
                </FormLabel>
                <Input
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: '0px', md: '0px' }}
                  type="email"
                  placeholder="mail@simmmple.com"
                  mb="24px"
                  fontWeight="500"
                  size="lg"
                  name="email"
                  onChange={handleChange}
                  value={formData?.email}
                />
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  display="flex"
                >
                  Password<Text color={brandStars}>*</Text>
                </FormLabel>
                <InputGroup size="md">
                  <Input
                    isRequired={true}
                    fontSize="sm"
                    placeholder="Min. 8 characters"
                    mb="24px"
                    size="lg"
                    type={show ? 'text' : 'password'}
                    variant="auth"
                    name="password"
                    onChange={handleChange}
                    value={formData?.password}
                  />
                  <InputRightElement
                    display="flex"
                    alignItems="center"
                    mt="4px"
                  >
                    <Icon
                      color={textColorSecondary}
                      _hover={{ cursor: 'pointer' }}
                      as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                      onClick={handleClick}
                    />
                  </InputRightElement>
                </InputGroup>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                    }}
                  >
                    {/* <Checkbox id="remember-login" colorScheme="brandScheme" />
                    <FormLabel
                      htmlFor="remember-login"
                      mb="0"
                      fontWeight="normal"
                      color={textColor}
                    >
                      Keep me logged in
                    </FormLabel> */}
                  </div>
                  
                  <Text fontWeight="400" fontSize="14px">
                    <NavLink to="/learnerforgotPassword">
                      <Text
                        as="span"
                        style={{
                          color: '#422AFB',
                        }}
                        fontWeight="500"
                      >
                        Forgot Password
                      </Text>
                    </NavLink>
                  </Text>
                </div>
                <Flex justifyContent="center" align="center" mb="24px">
                  <Text
                    color={textColorError}
                    fontSize="sm"
                    w="124px"
                    fontWeight="500"
                  >
                    {error}
                  </Text>
                </Flex>
                {alert && msg && (
                  <Text
                    color={textColorError}
                    fontSize="sm"
                    fontWeight="500"
                    mb="24px"
                  >
                    {msg}
                  </Text>
                )
                }
               
               {/* Desktop Layout */}
<Flex
  direction={{ base: "row", lg: "column" }}
  align="center"
  gap="16px"
  w="100%"
  mb="24px"
>
  <Button
    fontSize="sm"
    onClick={handleCheckLearner}
    variant="brand"
    fontWeight="500"
    w="100%"
    h="50px"
  >
    Sign In
  </Button>

  {/* OR text */}
  <Text
    fontWeight="600"
    color="gray.500"
    display={{ base: "block", lg: "none" }}
  >
    OR
  </Text>

  <Text
    fontWeight="600"
    color="gray.500"
    display={{ base: "none", lg: "block" }}
  >
   Or Continue with 
  </Text>


<Button
  onClick={login}
  variant="outline"
  w="100%"
  h="50px"
  border="1px solid"
  borderColor="gray.300"
  bg="white"
  color="#323130"
  fontWeight="600"
  leftIcon={
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
      alt="Microsoft"
      width="18"
      height="18"
    />
  }
>
  Microsoft
</Button>
</Flex>
                 </FormControl>
              <Flex
                flexDirection="column"
                justifyContent="center"
                alignItems="start"
                maxW="100%"
                mt="0px"
              >
               
              </Flex>
            </Flex>
          {/* )} */}
        </Flex>
       </Box>
      </DefaultAuth>
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
      {showEula && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.6)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          }}
        >
          <div
            style={{
              background: 'white',
              borderRadius: '12px',
              width: '700px',
              maxWidth: '90%',
              maxHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
              scrollBehavior: 'smooth',
              boxShadow:
                '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)',
            }}
          >
            <div
              style={{
                padding: '24px 32px 16px',
                borderBottom: '2px solid #e2e8f0',
                flexShrink: 0, // ← prevents it from shrinking
              }}
            >
              <h1
                style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  margin: 0,
                  color: '#1a202c',
                  textAlign: 'center',
                }}
              >
                {/* END USER LICENSE AGREEMENT (EULA) */}
                Platform Access and Privacy Acknowledgement
              </h1>
            </div>
            {/* Scrollable content */}
            <div
              style={{
                overflowY: 'auto',
                padding: '28px 32px',
                flex: 1,
                lineHeight: 1.6,
                color: '#1a202c',
              }}
            >
              <div
                style={{
                  // background: '#fef3c7',
                  // borderLeft: '4px solid #f59e0b',
                  // padding: '16px 20px',
                  marginBottom: '24px',
                  // borderRadius: '8px',
                  fontSize: '14px',
                  lineHeight: 1.6,
                  // color: '#92400e',
                }}
              >
                <strong>
                  By accessing the Atlantis training platform, you acknowledge
                  and agree that:
                </strong>
              </div>
              {/* <p style={{ marginBottom: '20px', fontSize: '15px' }}>
                This Agreement constitutes a legal agreement between you and
                Leadupp Private Limited ("LeadUpp"), the owner and operator of
                Atlantis ("Training Platform"). Its terms and conditions govern
                your use of the Training Platform.
              </p> */}
              <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                1. You will use the platform only for your assigned training and
                learning purposes.
              </p>
              <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                2. You will not share your login credentials or allow any other
                person to access the platform using your account. You are
                responsible for keeping your password and account information
                confidential.
              </p>{' '}
              <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                3. You will not reproduce, distribute, publicly display, modify
                or create derivative works from the platform, training modules
                or related materials, except where expressly permitted by
                LeadUpp or your organisation.
              </p>{' '}
              <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                4. You will not attempt to gain unauthorised access to the
                platform, its systems, source code or underlying data, including
                by reverse compiling, reverse assembling, reverse engineering or
                bypassing access controls.
              </p>{' '}
              <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                5. You will not misuse the platform, interfere with its
                security, bypass or manipulate any access restrictions or
                security-related features, knowingly introduce any virus,
                malware, spyware, Trojan horse or other harmful code, or scrape,
                harvest, extract or attempt to intercept any data from the
                platform, its underlying systems or communications.
              </p>{' '}
              <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                6. LeadUpp processes your personal data for purposes related to
                providing, operating and supporting the platform, including user
                authentication, access management, security, technical support,
                performance monitoring, usage analytics, reporting,
                troubleshooting, maintenance and product improvement. LeadUpp
                will process your personal data in accordance with LeadUpp’s{' '}
                <u>
                  <a
                    href="https://www.leadupp.co/privacypolicyleadupp.html"
                    target="blank"
                    style={{ color: 'blue' }}
                  >
                    Privacy Policy
                  </a>
                </u>
                .
              </p>{' '}
              <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                7. Your learning progress, completion status and related
                activity data will be available to your organisation for
                training administration, reporting and program evaluation
                purposes.
              </p>{' '}
              <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                8. Any information or materials made available to you through
                the platform, including the training modules, platform content
                and related materials, must be treated as confidential and must
                not be disclosed to any third party except as authorised by
                LeadUpp or your organisation.
              </p>
              <strong
                style={{
                  marginBottom: '24px',
                  // borderRadius: '8px',
                  fontSize: '14px',
                  lineHeight: 1.6,
                }}
              >
                By clicking Accept, you confirm that you have read, understood
                and agree to this Platform Access and Privacy Acknowledgement.
              </strong>
            </div>

            {/* Fixed footer with buttons */}
            <div
              style={{
                padding: '16px 24px',
                borderTop: '1px solid #e2e8f0',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '12px',
                background: '#f8fafc',
                borderRadius: '0 0 12px 12px',
              }}
            >
              <button
                onClick={async () => {
                  const person = localStorage.getItem('user');
                  const storedUser = JSON.parse(person);
                  // const userId = storedUser?.data?.id;
                  const userId = learnerId;
                  const data = { lenTerms: false };
                  await updateLearner(userId, JSON.stringify(data));

                  localStorage.removeItem('user');
                  setUser(null);
                  setShowEula(false);
                }}
              >
                Deny
              </button>
              <button
                onClick={async () => {
                  const person = localStorage.getItem('user');
                  const storedUser = JSON.parse(person);
                  // const userId = storedUser?.data?.id;
                  const userId = learnerId;
                  const data = { lenTerms: true };
                  const res = await updateLearner(userId, JSON.stringify(data));
                  if (res.status === 'Success') {
                    handleLogin(new Event('submit'));
                  }
                }}
                style={{
                  padding: '10px 24px',
                  borderRadius: '8px',
                  background: '#422AFB',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SignIn;
